import { ClipLoader } from 'react-spinners'

import { Page } from 'src/components/layouts/Page'

export const Redirecting = () => {
  return (
    <Page>
      <ClipLoader cssOverride={{ display: 'block' }} className='m-auto' />
    </Page>
  )
}
